import { selectActivePickemDetails } from "selectors/PickemDetails";
import { EmptyGrowPanelText } from "styles/text";
import { ActivePickemOption } from "./ActivePickemOption";
import { useAppSelector } from "app/hooks";
import { shallowEqual } from "react-redux";
import { PanelList } from "components/PanelList/PanelList";

export const ActivePickems = () => {
  const activePickemDetails = useAppSelector(
    selectActivePickemDetails,
    shallowEqual
  );

  if (activePickemDetails.length === 0) {
    return <EmptyGrowPanelText>No Active Pick'ems</EmptyGrowPanelText>;
  }

  const sortedPickemDetails = activePickemDetails.sort(
    (a, b) => a.closeTime - b.closeTime
  );

  return (
    <PanelList>
      {sortedPickemDetails.map(
        ({ pickemId, tournamentId, name, closeTime }) => {
          return (
            <ActivePickemOption
              key={`${tournamentId} - ${pickemId}`}
              pickemId={pickemId}
              tournamentId={tournamentId}
              name={name}
              closeTime={closeTime}
            />
          );
        }
      )}
    </PanelList>
  );
};
